const initialState = {
    fetchingInterests: true,
    interests: [],
    categoryTree: [],
    userCreation: {},
    videoPlaying: null,
    admin: {
        categoryTree: [],
    },
    curatorPlatforms: [
        'Blog',
        'Digital Magazine',
        'Facebook',
        'Instagram',
        'Medium',
        'Pinterest',
        'Twitter',
        'Tumblr',
        'YouTube',
        'Other',
    ],
    generalListCardSettings: {
        itemsPerRow: 3,
        responsive: {
            '1280': { itemsPerRow: 3 },
            '1152': { itemsPerRow: 2 },
            '840': { itemsPerRow: 2 },
            '725': { itemsPerRow: 1 },
        },
    },
};

export default function vars(state = initialState, action) {
    switch ( action.type ) {
        case 'REQUEST_VARS_INTERESTS':
            return {
                ...state,
                fetchingInterests: true,
                interests: [],
            };
        case 'RECEIVE_VARS_INTERESTS':
            return {
                ...state,
                fetchingInterests: false,
                interests: action.interests,
            };
        case 'UPDATE_VARS':
            return {
                ...state,
                ...action.obj,
            };
        default:
            return state;
    }
}
